var map = {
	"./email.svg": 97,
	"./github.svg": 98,
	"./linkedin.svg": 99,
	"./medium.svg": 100,
	"./twitter.svg": 101
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;


//////////////////
// WEBPACK FOOTER
// ./src/assets/social nonrecursive \.svg$
// module id = 127
// module chunks = 1